<template>
  <!-- 个人中心-个人信息 -->
  <div class="main-contain">
    <div class="contain">
      <div class="theme">账号安全</div>
      <div class="list">
        <el-row class="item">
          <el-col :span="24">
            <div class="title">账户密码</div>
          </el-col>
          <el-col :span="20">
            <div class="text">
              当前密码强度:
              <span class="text-s">{{ userinfo.password_strength }}</span>
            </div>
          </el-col>
          <el-col :span="4" class="btcontain">
            <el-button type="text" @click="editor(0)">修改</el-button>
          </el-col>
        </el-row>
        <el-row class="item">
          <el-col :span="24">
            <div class="title">密保手机</div>
          </el-col>
          <el-col :span="20">
            <div class="text">已绑定手机：{{ userinfo.mobile }}</div>
          </el-col>
          <el-col :span="4" class="btcontain">
            <el-button type="text" @click="editor(1)">修改</el-button>
          </el-col>
        </el-row>
        <el-row class="item">
          <el-col :span="24">
            <div class="title">绑定邮箱</div>
          </el-col>
          <el-col :span="20">
            <template v-if="userinfo.email">
              <div class="text">已绑定邮箱：{{ userinfo.email }}</div>
            </template>
            <template v-else>
              <div class="text">未绑定邮箱</div>
            </template>
          </el-col>
          <el-col :span="4" class="btcontain">
            <template v-if="userinfo.email">
              <el-button type="text" @click="editor(2)">修改</el-button>
            </template>
            <template v-else>
              <el-button type="text" @click="editor(2)">绑定邮箱</el-button>
            </template>
          </el-col>
        </el-row>
      </div>
    </div>
    <Customdialog ref="customdialog" type="min0" :title="title" width="700px" :showclose="true">
      <div slot="dialogbody" class="dialogbody">
        <component :is="componentId" ref="component" :close="close" @setNewEmail="getUserInfo"></component>
      </div>
      <div slot="dialogfooter" class="dialogfooter">
        <el-button class="btn-primary" plain size="small" @click="resetpass('ruleForm')">取消</el-button>
        <el-button class="btn-primary" size="small" @click="submitpass('ruleForm')">确定</el-button>
      </div>
    </Customdialog>
  </div>
</template>
<script>
import Pass from "./pass"
import Mobile from "./mobile"
import eMail from "./email"

import { setWebAvaterToken } from "@/utils/auth"
import Customdialog from "@/components/customdialog.vue"
import dayjs from "dayjs"
import { getuserinfo, edituserinfo } from "@/api/user"
export default {
  name: "virtualsimulation",
  components: {
    Customdialog,
    Pass,
    Mobile,
    eMail,
  },
  data() {
    return {
      componentId: "Pass",
      title: "",
      imageUrl: "",
      activeName: "first",
      userinfo: {},
      isclear: false,
      rules: {
        // name: [
        //   { required: true, message: '请输入用户姓名', trigger: ['blur', 'change'] }
        // ],
      },
    }
  },
  filters: {
    dataformat(value) {
      if (!value) return ""
      return dayjs.unix(value).format("YYYY-MM-DD HH:mm:ss")
    },
  },
  created() {
    this.getUserInfo() // 获取用户信息
  },
  methods: {
    /* 安全设置 */
    close() {
      this.$refs.customdialog.dialogclosebt()
    },
    editor(type) {
      this.$refs.customdialog.dialogopenbt()
      this.$nextTick(() => {
        // 刷新计时器，验证码
        let timer = this.$refs.component.timer
        if (timer) {
          this.$refs.component.count = ""
          this.$refs.component.show = true
          clearInterval(timer)
        }
        if (type == 0) {
          this.componentId = "Pass"
          this.title = "修改账户密码"
        } else if (type == 1) {
          this.componentId = "Mobile"
          this.title = "修改绑定手机"
        } else if (type == 2) {
          this.componentId = "eMail"
          this.title = "绑定邮箱"
          sessionStorage.setItem('oldEmail', this.userinfo.email)
        }
        this.$refs.component.resetForm("ruleForm")
      })
    },
    submitpass() {
      this.$refs.component.submitForm("ruleForm")
    },
    resetpass() {
      this.$refs.component.resetForm("ruleForm")
      this.$refs.customdialog.dialogclosebt()
    },
    getUserInfo(params) {
      getuserinfo(params)
        .then((response) => {
          switch (response.data.password_strength) {
            case 0:
              response.data.password_strength = "弱"
              break
            case 1:
              response.data.password_strength = "一般"
              break
            case 2:
              response.data.password_strength = "强"
              break
          }
          this.imageUrl = response.data.avatar
          this.userinfo = response.data
        })
        .catch((error) => { })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!')
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    //更新个人信息
    edituserinfo(params) {
      let that = this
      if (this.isclear) {
        params.avatar = null
      }
      edituserinfo(params).then((response) => {
        if (response.code === 0) {
          that.$store.commit("SET_Useravater", response.data.avatar)
          that.$store.commit("SET_Username", response.data.name)
          setWebAvaterToken(response.data.avatar)
          this.$message({
            message: "个人信息更新成功!",
            type: "success",
          })
        }
        this.getUserInfo()
      }).catch((error) => { })
    },
    getUrl(data) {
      const url = JSON.parse(data)
      if (url.length > 0) {
        this.form.avatar = url[0].url
      }
      this.edituserinfo({
        name: this.userinfo.name,
        avatar: this.form.avatar,
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.main-contain {
  padding: 10px;

  .contain {
    height: 100%;
    background: #ffffff;
    box-sizing: border-box;
    padding: 20px 80px;

    .theme {
      color: #000000;
      font-size: 16px;
      font-weight: bold;
      line-height: 30px;
      margin-bottom: 20px;
    }

    .list {
      .item {
        padding: 10px 0;
        border-bottom: 1px solid #f7f7f7;

        .title {
          color: #000000;
          font-size: 14px;
          font-weight: 400;
          line-height: 30px;
          margin: 0;
        }

        .text {
          color: #999999;
          font-size: 14px;
          font-weight: 400;
          line-height: 40px;

          .text-s {
            color: #005cbb;
          }
        }

        .btcontain {
          text-align: right;
        }
      }
    }
  }

  .customdialog {
    .dialogfooter {
      border-top: 1px solid #cccccc;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.btn-primary {
  color: #fff;
  background-color: #005cbb;
  border-color: #005cbb;
}

.btn-primary.is-plain {
  color: #005cbb;
  background: #fff;
  border-color: #005cbb;
}

@media screen and (max-width: 640px) {
  .main-contain {
    padding: 5px;

    .contain {
      padding: 15px 10px;

      .theme {
        text-indent: 0;
        font-size: 16px;
      }

      ::v-deep .el-row {
        .el-col {
          width: 100%;
          max-width: 100%;
          flex: 0 0 100%;
        }
      }

      .form-box {
        ::v-deep .el-form-item__label {
          width: 80px !important;
        }

        ::v-deep .el-form-item__content {
          margin-left: 80px !important;
        }
      }
    }
  }
}
</style>